<template>
  <div class="riiqosxn riiqosxn-one cu_management_row">
    <v-container>
      <h1 class="title-lg">Customer Management</h1>
    </v-container>
    <div class="riiqosxn-one__item">
      <v-container>
        <v-row >
          <v-col cols="12" md="6" class="col-content">
            <h5>MANAGEMENT MADE EASY</h5>
            <p>From conception to sale, and far beyond, customize your visual data so you can always find what you are looking for. Schedule appointments, track customers through your processes, and always know their status and take the difficult management out of the relationship.</p>
            <router-link to="contact" class="btn btn-getstarted">Get Started</router-link>
          </v-col>
        </v-row>
      </v-container>
      <div class="img-container"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SxnOne',

  data: () => ({
    
  }),
};
</script>